<div>
  @if (this.fields.length > 0) {
    <app-dynamic-form
    #dynamicFormComponent
      [fields]="fields"
      [type]="'horizontal'"
      [translation]="true"
      (changes)="detectFormState($event)"
      (action)="buttonAction($event)"
      (formChanges)="formChange($event)"></app-dynamic-form>
  }
</div>
<div class="footer-buttons">
  <div class="flex">
    <div class="flex-1">
      <button
        pButton
        type="button"
        label="{{ 'buttons.cancel' | translate }}"
        [outlined]="true"
        icon="pi pi-times-circle"
        (click)="exitDialog()"></button>
    </div>
    @if (buttonOutlined) {
      <button
        pButton
        type="button"
        label="{{ 'buttons.validate' | translate }}"
        [outlined]="buttonOutlined"
        icon="pi pi-check-circle"
        (click)="closeDialog()"
        [disabled]="!buttonEnabled"></button>
    } @else {
      <button
        pButton
        type="button"
        label="{{ 'buttons.validate' | translate }}"
        icon="pi pi-check-circle"
        (click)="closeDialog()"
        [disabled]="!buttonEnabled"></button>
    }
  </div>
</div>
<p-toast></p-toast>